module.exports = __webpack_public_path__ + "static/media/Service_Technicians_at_Work.85ab237f.png";